module.exports = __webpack_public_path__ + "static/media/externalLink.2c7d1528.svg";